import React from 'react';

type StatusVariant =
  | 'quarantine' |'available' |'reserved' |'picked' |'kitting' |'packed' |'dispatched' |'damaged' |'expired' |'pending' |'complete' |'inprogress';

interface StatusBadgeProps {
  status: StatusVariant;
  label?: string;
  size?: 'sm' | 'md';
}

const labelMap: Record<StatusVariant, string> = {
  quarantine: 'Quarantine',
  available: 'Available',
  reserved: 'Reserved',
  picked: 'Picked',
  kitting: 'Kitting',
  packed: 'Packed',
  dispatched: 'Dispatched',
  damaged: 'Damaged',
  expired: 'Expired',
  pending: 'Pending',
  complete: 'Complete',
  inprogress: 'In Progress',
};

export default function StatusBadge({ status, label, size = 'md' }: StatusBadgeProps) {
  const displayLabel = label ?? labelMap[status] ?? status;
  const sizeClass = size === 'sm' ? 'text-2xs px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold ${sizeClass} badge-${status}`}>
      <span className="status-dot" style={{ backgroundColor: 'currentColor', width: '5px', height: '5px' }} />
      {displayLabel}
    </span>
  );
}